module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonecvm-bottom-01.2.b415ed51.jpg";